'use client';

import { showGMsgAsToast } from '@/shared/globalFunctions';
import { useManagerEntity } from '@/shared/managerHelpers';
import { observer } from 'mobx-react';

export default observer(function GMsgToastSubscriber() {

  const manager = useManagerEntity();

  if (!manager) return <div></div>;

  showGMsgAsToast(manager.gMsg);

  // This component doesn't render anything
  return null;
})